export const SITE_URL = 'https://www.krewsup.com';

export const PAGES = [
  {
    path: '/',
    ids: ['home'],
    name: 'Home',
    title: 'KrewsUp | Brew Your Connections',
    description: "KrewsUp is India's first KYC-verified event crew marketplace. Hire verified crew, crew suppliers and vendors for every event, with OTP check-in and escrow payouts. Your first event is free.",
  },
  {
    path: '/about',
    ids: ['about'],
    name: 'About',
    title: 'About KrewsUp | India’s First KYC-Verified Event Crew Marketplace',
    description: 'KrewsUp brings verified crew and vendors to every event at your venue. Crew keep 100% of their pay. Nobody gets ghosted. Live in Bengaluru.',
  },
  {
    path: '/platform',
    ids: ['platform'],
    name: 'What is KrewsUp',
    title: 'What is KrewsUp | One App for Every Hand Your Event Needs',
    description: 'Post your requirement, verified crew accept, OTP check-in and out, and escrow auto payout. ₹99 crew deposit, under 10% no-show rate and same-day payouts.',
  },
  {
    path: '/services',
    ids: ['services'],
    name: 'Services',
    title: 'Services | KrewsUp',
    description: 'Hire crew individually, hire via crew suppliers, manage vendors for sound, light, decor, print and logistics, plus sponsorship and ticketing services.',
  },
  {
    path: '/why-krewsup',
    ids: ['why'],
    name: 'Why KrewsUp',
    title: 'Why KrewsUp | Seven Reasons to Brew With Us',
    description: 'Seven reasons organizers and krews choose KrewsUp: instant gigs, same-day payments, verified profiles, a pan-India network, a mobile-first app, performance analytics and skill development.',
  },
  {
    path: '/compare',
    ids: ['compare'],
    name: 'WhatsApp vs KrewsUp',
    title: 'WhatsApp Hiring vs KrewsUp | KrewsUp',
    description: 'Compare hiring event crew on WhatsApp groups with KrewsUp: under 10% no-shows, KYC-verified identity, OTP attendance, escrow payments and same-day replacement.',
  },
  {
    path: '/pricing',
    ids: ['pricing'],
    name: 'Pricing',
    title: 'Pricing | KrewsUp: Simple Pricing, First Event Free',
    description: 'No joining fee, no subscription. Your first event is free with a 0% platform fee. From event 2, a 13% service fee on Krew billing, plus 10% to a Crew Supplier only if you book through one. Krews keep 100% of their pay.',
  },
  {
    path: '/how-it-works',
    ids: ['how'],
    name: 'How It Works',
    title: 'How It Works | KrewsUp',
    description: 'Five simple moves on KrewsUp, from sign-up to payout: create your profile, find and post gigs, connect and confirm, complete the gig, then get paid and review.',
  },
  {
    path: '/customers',
    ids: ['customers'],
    name: 'Customers',
    title: 'Our Customers | KrewsUp',
    description: 'One platform for both sides of every event: event organizers, corporate teams, production houses and skilled professionals looking for flexible work.',
  },
  {
    path: '/partners',
    ids: ['partners'],
    name: 'Partners',
    title: 'Partners | KrewsUp',
    description: 'Partners KrewsUp already works with in Bengaluru, including The Leela Palace Bengaluru, Events Factory, RollTheDice, Urbanaut, DNA Networks, Dream Events, TOCA and BigBang Events.',
  },
  {
    path: '/stories',
    ids: ['stories'],
    name: 'Stories',
    title: 'Win-Win Stories | KrewsUp',
    description: 'Every event has two sides. With KrewsUp, both of them win. Stories from Events Factory, RollTheDice, Urbanaut and ABC India, and the krews who worked their events.',
  },
  {
    path: '/faq',
    ids: ['faq'],
    name: 'FAQ',
    title: 'FAQ | KrewsUp',
    description: 'Answers about signing up as a gig worker, types of gigs, payouts, fees and how KrewsUp ensures quality.',
  },
  {
    path: '/partner-with-us',
    ids: ['partner'],
    name: 'Partner With Us',
    title: 'Partner With Us | KrewsUp',
    description: 'Three steps, zero risk: onboard free with no lock-in, get your first event on us with a 0% platform fee, then grow together with partner pricing and referral share.',
  },
  {
    path: '/contact',
    ids: ['connect', 'contact'],
    name: 'Contact',
    title: 'Contact KrewsUp | Got a Question? Let’s Talk',
    description: 'Hosting an event, joining as a krew or supplying crew? Email raghav@krewsup.com, call +91 82960 58467 or chat with KrewsUp on WhatsApp.',
  },
];

export const PATH_BY_ID = PAGES.reduce((map, page) => {
  page.ids.forEach((id) => { map[id] = page.path; });
  return map;
}, {});

export const ID_BY_PATH = PAGES.reduce((map, page) => {
  map[page.path] = page.ids[0];
  return map;
}, {});
